import { c as _c } from "react/compiler-runtime";
import { Button, Input, HStack, Heading, VStack, Dialog, Field } from '@chakra-ui/react';
import React, { useRef, useState, useEffect } from 'react';
interface LinkModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialUrl: string;
  initialLabel?: string;
  onSubmit: (url: string, label?: string) => void;
  onRemove?: () => void;
  title: string;
}
export const LinkModal: React.FC<LinkModalProps> = t0 => {
  const $ = _c(54);
  const {
    isOpen,
    onClose,
    initialUrl,
    initialLabel: t1,
    onSubmit,
    onRemove,
    title
  } = t0;
  const initialLabel = t1 === undefined ? "" : t1;
  const [url, setUrl] = useState(initialUrl);
  const [label, setLabel] = useState(initialLabel || url);
  const initialRef = useRef(null);
  let t2;
  let t3;
  if ($[0] !== initialLabel || $[1] !== initialUrl) {
    t2 = () => {
      setUrl(initialUrl);
      setLabel(initialLabel || initialUrl);
    };
    t3 = [initialUrl, initialLabel];
    $[0] = initialLabel;
    $[1] = initialUrl;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== label || $[5] !== onClose || $[6] !== onSubmit || $[7] !== url) {
    t4 = ev => {
      if (ev && ev.preventDefault) {
        ev.preventDefault();
      }
      onSubmit(url, label);
      onClose();
    };
    $[4] = label;
    $[5] = onClose;
    $[6] = onSubmit;
    $[7] = url;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleSubmit = t4;
  let t5;
  if ($[9] !== onClose || $[10] !== onRemove) {
    t5 = () => {
      if (onRemove) {
        onRemove();
        onClose();
      }
    };
    $[9] = onClose;
    $[10] = onRemove;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handleRemove = t5;
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => initialRef.current;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== onClose) {
    t7 = t8 => {
      const {
        open
      } = t8;
      if (!open) {
        onClose();
      }
    };
    $[13] = onClose;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Dialog.Backdrop />;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Dialog.CloseTrigger />;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== title) {
    t10 = <Heading marginBottom={2} marginTop={4} size="md">{title}</Heading>;
    $[17] = title;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Field.Label>URL</Field.Label>;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = e => setUrl(e.target.value);
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== url) {
    t13 = <Field.Root>{t11}<Input ref={initialRef} placeholder="https://example.com" required={true} size="sm" type="url" value={url} onChange={t12} /></Field.Root>;
    $[21] = url;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Field.Label>Label</Field.Label>;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = e_0 => setLabel(e_0.target.value);
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== label) {
    t16 = <Field.Root>{t14}<Input placeholder="Link text" size="sm" value={label} onChange={t15} /></Field.Root>;
    $[25] = label;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t13 || $[28] !== t16) {
    t17 = <VStack align="stretch" gap={3}>{t13}{t16}</VStack>;
    $[27] = t13;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  const t18 = !onRemove;
  let t19;
  if ($[30] !== handleRemove || $[31] !== t18) {
    t19 = <Button disabled={t18} size="sm" variant="outline" onClick={handleRemove}>Remove Link</Button>;
    $[30] = handleRemove;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== onClose) {
    t20 = <Button size="sm" variant="outline" onClick={onClose}>Close</Button>;
    $[33] = onClose;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== handleSubmit) {
    t21 = <Button size="sm" type="submit" onClick={handleSubmit}>Save</Button>;
    $[35] = handleSubmit;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t20 || $[38] !== t21) {
    t22 = <HStack gap={2} justify="flex-end">{t20}{t21}</HStack>;
    $[37] = t20;
    $[38] = t21;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t19 || $[41] !== t22) {
    t23 = <HStack gap={2} justify="space-between" marginY={4}>{t19}{t22}</HStack>;
    $[40] = t19;
    $[41] = t22;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== handleSubmit || $[44] !== t17 || $[45] !== t23) {
    t24 = <form onSubmit={handleSubmit}>{t17}{t23}</form>;
    $[43] = handleSubmit;
    $[44] = t17;
    $[45] = t23;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== t10 || $[48] !== t24) {
    t25 = <Dialog.Positioner><Dialog.Content bgColor="colorPalette.container">{t9}<Dialog.Body>{t10}{t24}</Dialog.Body></Dialog.Content></Dialog.Positioner>;
    $[47] = t10;
    $[48] = t24;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== isOpen || $[51] !== t25 || $[52] !== t7) {
    t26 = <Dialog.Root initialFocusEl={t6} open={isOpen} onOpenChange={t7}>{t8}{t25}</Dialog.Root>;
    $[50] = isOpen;
    $[51] = t25;
    $[52] = t7;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  return t26;
};